import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function CateringInPune() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="content" className="site-content">
      <div className="ast-container">
        <article className="page type-page status-publish ast-article-single">
          <div className="entry-content clear">
            <section className="elementor-section elementor-top-section" style={{ padding: '70px 20px' }}>
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100">
                  <div className="elementor-widget-container">
                    <h1>Catering in Pune and Baner</h1>
                    <p>
                      TSR Catering provides tailored catering for weddings, corporate events, family gatherings and
                      celebrations across Pune. From our Baner location, our team helps you plan menus and service that
                      fit your guests, event style and budget.
                    </p>
                    <h2>Looking for caterers near Baner?</h2>
                    <p>
                      Whether you are hosting a wedding, engagement, birthday party, office event or buffet, TSR
                      Catering offers fresh food, professional service and support from planning through the event.
                      We serve Baner, Pune and surrounding neighbourhoods.
                    </p>
                    <h2>Catering services for every occasion</h2>
                    <ul>
                      <li>Wedding and pre-wedding catering</li>
                      <li>Corporate meetings, launches and employee events</li>
                      <li>Buffet catering for family gatherings and celebrations</li>
                      <li>Social-event, party and canteen catering</li>
                    </ul>
                    <p>
                      Explore our <Link to="/catering">catering services</Link>, view our <Link to="/menu">menu ideas</Link>,
                      or <Link to="/contact">contact TSR Catering</Link> to discuss your event in Pune.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </main>
  );
}

export default CateringInPune;
